module.exports = __webpack_public_path__ + "media/images/ui__infoBoxSmall--dark-81338c60ea5e091df63272b2065f4cdf.png";